import { useSelector } from 'react-redux';

import type { ReduxState } from 'app/redux/types';

import { matchIds as favoritesMatchIds } from 'app/modules/Favorites/selectors/gridEntities';


export const useMatchInFavorites = (matchId: number) => {
  return useSelector((state: ReduxState) => favoritesMatchIds(state).includes(matchId));
};
